import React from 'react';
import ConfirmationModal from './ConfirmationModal';
import type { Keypair } from '../store/slices/keypairsSlice';

interface DeleteKeypairModalProps {
    isOpen: boolean;
    keypair: Keypair | null;
    onClose: () => void;
    onConfirm: () => void;
    isDeleting: boolean;
}

const DeleteKeypairModal: React.FC<DeleteKeypairModalProps> = ({
    isOpen,
    keypair,
    onClose,
    onConfirm,
    isDeleting,
}) => {
    if (!keypair) return null;

    return (
        <ConfirmationModal
            isOpen={isOpen}
            onClose={onClose}
            onConfirm={onConfirm}
            title="Delete SSH key"
            confirmText="Delete key"
            cancelText="Keep key"
            type="danger"
            isConfirming={isDeleting}
            message={
                <>
                    <p>Delete this SSH key? It cannot be restored. Existing virtual machines keep running and retain their current authorized keys, but this key cannot be selected for new virtual machine launches.</p>
                    <div className="keypair-delete-details">
                        <div className="keypair-delete-row">
                            <span className="keypair-delete-label">Name</span>
                            <span className="keypair-delete-value">{keypair.name}</span>
                        </div>
                        <div className="keypair-delete-row">
                            <span className="keypair-delete-label">Fingerprint</span>
                            <span className="keypair-delete-value keypair-delete-fingerprint">{keypair.fingerprint}</span>
                        </div>
                    </div>
                </>
            }
        />
    );
};

export default DeleteKeypairModal;
